import React, {useState, useEffect, useCallback} from 'react'
import { useParams } from 'react-router-dom';
import {Spinner} from '@material-tailwind/react'
import { debounce, random } from 'lodash';
import toast, { Toaster } from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid';
import { useSelector, useDispatch } from 'react-redux';
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import moment from 'moment';

import { encodedAddressPrefix, tippingAddress, ownerAddress, royalty, tip, contentLength, serviceFeeRate, padding, royalty_pa, brc20BridgeFee, brc20ClaimFeeAddress, brc20ClaimOwnerAddress } from '../../configs/constant';
import { Input } from '@material-tailwind/react'
import { formatAddress, formatInscriptionId } from '../../util/format-data'
import { registerPaymentRandom, latestTokenRandom, checkWhiteListedAddress, registerTokenRandomIndividual, getPaymentTx, getPaymentUtxosRandom, getPaymentHistoryNew, savePaymentHistoryNew, getSignMintTextRandom, getMintStatus, checkWhiteListedDomain, getPATokenDetail, getLaunchpadTickers, launchpadTokenRandom, registerLaunchpadHistory } from '../../util/new-api'
import { getAsciiSum } from '../../util/format-data';
import { getFeeRate, bytesToHex, buf2hex, textToHex, hexToBytes, getMempoolUtxos, loopTilAddressReceivesMoney, waitSomeSeconds, addressReceivedMoneyInThisTx, pushBTCpmt, getData, isValidTaprootAddress, calculateFee} from '../../util/inscribe-util';
import FeeRateCard from '../../components/FeeRateCard';
import { BitcoinNetworkType, signMessage, signTransaction, sendBtcTransaction } from 'sats-connect';
import { latestTokenNew, getPATokenWhitelistAddressCheck } from '../../util/new-api';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { getPaymentUtxos } from '../../util/new-api';
import { savePaymentHistory } from '../../util/api';
import { brc20PresaleFeeRate, brc20PresaleFee, brc20PresaleFeeAddress } from '../../configs/constant';
import { generateRandomKey } from '../../util/format-data';
import logoImg from '../../assets/imgs/🝯.png';
import { formatFloat } from '../../util/format-data';
import { DocumentDuplicateIcon, XMarkIcon} from '@heroicons/react/24/outline';
import { isMobile } from 'react-device-detect';
import { payWithSolflareWallet, payWithMagicEdenWallet } from '../../util/solana-api';
import { broadcastBitcoinTransaction }from '../../util/new-api';

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
  Chip,
  Avatar,
  IconButton,
  Tooltip,
  Slider,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Progress,
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

import { useWallet, useWallets } from '@wallet-standard/react';
import { getPATokenMintTickersForBrc20 } from '../../util/new-api';
import CountdownCard from '../../components/CountdownCard';
import { useTranslation } from 'react-i18next';
import { getAllBrc20AdminList, getAllBrc20HistoryList, registerBrc20HistoryData, getBrc20Sum, getSolanaCreatePaymentSession, sendSolanaTransaction, saveBrc20ClaimData, updateBrc20ClaimData, getBrc20ClaimData, getAllBrc20ClaimData, getBrc20ClaimTransactionData } from '../../util/brc20-api';
import { SolanaQRCode } from '../../components/QRCode/SolanaQRCode';
import { Keypair, Connection, LAMPORTS_PER_SOL} from '@solana/web3.js';
import { getSolanaBalance } from '../../util/brc20-api';
import SolanaConnect from '../../components/SolanaConnect';
import { payWithPhantomWallet } from '../../util/solana-api';
import { BitcoinQRCode } from '../../components/QRCode/BitcoinQRCode';
import claimData from './tap-claim.json';
import Connect from '../../components/Connect';

export default function Brc20ClaimTap() {
  //const { param } = useParams();
  const param = "tap";

  const { t, i18n } = useTranslation();
  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const wallet = useSelector(state => state.wallet);
  const solanaWallet = useSelector(state => state.solanaWallet);
  const prices = useSelector(state => state.price);

  const { Address, Script, Signer, Tap, Tx } = window.tapscript;

  const cryptoUtils = window.cryptoUtils;
  const KeyPair = cryptoUtils.KeyPair;

  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [timeLeft, setTimeLeft] = useState({});
//   const targetDate = moment.utc('2025-01-07T18:00:00');
  const [mintStart, setMintStart] = useState(true);

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(0);
  const feeRates = useSelector(state => state.feeRate);
  const [feeValues, setFeeValues] = useState({
    "inscriptionFee": 0,
    "networkFee": 0,
    "serviceFee": 0,
    "royaltyFee": 0,
    "totalFee": 0
  });
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [domain, setDomain] = useState('');
  const [amount, setAmount] = useState(10000);
  const [maximum, setMaximum] = useState(21000);
  const [sum, setSum] = useState(0);
  const [deployLimit, setDeployLimit] = useState(210000000000);
  const [receiveAddress, setReceiveAddress] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [key, setKey] = useState('');
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [show, setShow] = useState(false);
  const [inscriptionStatus, setInscriptionStatus] = useState(false);
  const [open, setOpen] = useState(0);
  const [claimAmount, setClaimAmount] = useState(0);
  const [fees, setFees] = useState({
    "totalFee": 0,
    "inscribeFee": 0,
    "transferFee": 0,
    "serviceFee": 5000
  });
  const [serviceAddress, setServiceAddress] = useState("");
  const [receiveTokenAmount, setReceiveTokenAmount] = useState(0);
  const [privateKey, setPrivateKey] = useState("");
  const [fundingAddress, setFundingAddress] = useState("");
  const [inscriptionAddress, setInscriptionAddress] = useState("");

  const [ticker, setTicker] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [minAmount, setMinAmount] = useState(0);
  const [mintEnd, setMintEnd] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [currentSum, setCurrentSum] = useState(0);
  const [description, setDescription] = useState("");
  const [btcAmount, setBtcAmount] = useState(0.001);
  const [percent, setPercent] = useState(0);
  const [solanaData, setSolanaData] = useState({});
  const [transactionStatus, setTransactionStatus] = useState(false);
  const [receiveSuccess, setReceiveSuccess] = useState(false);
  const [payStatus, setPayStatus] = useState(false);
  const [softCap, setSoftCap] = useState(0.01);
  const [hardCap, setHardCap] = useState(0.25);
  const [mintHardEnd, setMintHardEnd] = useState(false);
  const [payReceiveStatus, setPayReceiveStatus] = useState(false);

  const [flag, setFlag] = useState(1);
  const ratio = parseInt(prices.bitcoin / prices.solana);

  useEffect(() => {
    const updateCountdown = () => {
      const now = moment.utc();

      const duration1 = moment.duration(moment.utc(startTime).diff(now));
      const duration2 = moment.duration(moment.utc(endTime).diff(now));
      const duration3 = moment.duration(moment.utc(endTime).diff(moment.utc(startTime)));

      if (duration2 > duration3) {
        setPercent(0);
      }
      else {
        setPercent(Math.ceil((duration3 - duration2) / duration3 * 100));
      }

      if (totalAmount >= hardCap * Math.pow(10, 8)) {
        setMintStart(false);
        setMintEnd(true);
        clearInterval(timer);
        return;
      }

      if (duration1.asSeconds() > 0) {
        setTimeLeft({
          days: Math.floor(duration1.asDays()),
          hours: Math.floor(duration1.hours()),
          minutes: Math.floor(duration1.minutes()),
          seconds: Math.floor(duration1.seconds()),
        });
        setMintStart(false);
        setMintEnd(false);
      }
      else if (duration2.asSeconds() > 0) {
        setTimeLeft({
          days: Math.floor(duration2.asDays()),
          hours: Math.floor(duration2.hours()),
          minutes: Math.floor(duration2.minutes()),
          seconds: Math.floor(duration2.seconds()),
        });
        setMintStart(true);
        setMintEnd(false);
      }
      else if (duration2.asSeconds() <= 0) {
        setMintStart(true);
        setMintEnd(true);
        clearInterval(timer);
        return;
      }
    };

    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, [param, startTime, endTime, minAmount, totalAmount]);

  useEffect(() => {
    const checkBitcoinTransaction = async () => {
      if (fundingAddress != "" && payReceiveStatus == false && transactionStatus == false && (open == 1 || payStatus == true)) {
        let transactionData = await getMempoolUtxos(fundingAddress);
        
        if (transactionData.length > 0 && transactionData[0].value >= fees.totalFee) {
          setPayReceiveStatus(true);
          handlePaySuccess(transactionData[0]);
        }
      }
    }

    const timer = setInterval(checkBitcoinTransaction, 10000);

    return () => {
      clearInterval(timer);
    }
  }, [fundingAddress, payReceiveStatus, open, payStatus, show, transactionStatus])

  useEffect(() => {
    handleMintTickers();
  }, [param])

  useEffect(() => {
    setAmount(Math.ceil(parseFloat(btcAmount) * Math.pow(10, 8)))
  }, [btcAmount])

  const handleMintTickers = async () => {
    let results = await getAllBrc20AdminList(param);
    getPATokenAdmin(results.data[0]) // fehu (ᚠ)
  }

  const getPATokenAdmin = async (tickerData) => {
    setServiceAddress(tickerData.receiveAddress);
    setDescription(tickerData.description);
    let startTimes = tickerData.startTime.split('-');
    setStartTime(startTimes[0] + '-' + startTimes[1] + '-' + startTimes[2] + 'T' + startTimes[3] + ':00:00');
    let endTimes = tickerData.endTime.split('-');
    setEndTime(endTimes[0] + '-' + endTimes[1] + '-' + endTimes[2] + 'T' + endTimes[3] + ':00:00');
    setTicker(tickerData.ticker);
    setSoftCap(tickerData.softCap);
    setHardCap(tickerData.hardCap);
    setMinAmount(tickerData.hardCap * Math.pow(10, 8));
    setMintHardEnd(tickerData.mintEnd == 1 ? true : false);
  }

  useEffect(() => {
    let intervalId;

    const updateFees = async () => {
      try {
        if (feeRateMode == "Custom") {
          setFeerate(customFee);
        }
        else
        {
          setFeerate(feeRates[feeRateMode]);
          if (customFee == 0) 
          {
            setCustomFee(feeRates["Fast"] + 1);
          }
        }
      }
      catch (e) {
        console.log(e);
      }
    }
    updateFees();
    intervalId = setInterval(updateFees, 20 * 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [feeRateMode, customFee, feeRates])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  useEffect(() => {
    fees.inscribeFee = Math.ceil((160 + 86 / 4) * feerate) + padding;
    fees.transferFee = Math.ceil(169 * feerate); // 10 + 57.5 + 43
    if (fees.transferFee < padding) {
      fees.transferFee = padding;
    }
    fees.totalFee = Math.ceil(fees.inscribeFee + fees.transferFee + fees.serviceFee + 214 * feerate);
  }, [feerate])

  useEffect(() => {
    handleReceiveAddress();
  }, [receiveAddress])

  const handleReceiveAddress = async() => {
    let flag = false;
    let amount = 0;
    for (let i = 0; i < claimData.length; i++) {
      if (claimData[i].address == receiveAddress) {
        flag = true;
        amount = parseFloat(claimData[i].amount) * 10000; // ratio
        break;
      }
    }

    if (receiveAddress != "") {
      let resData = await getBrc20ClaimData({
        ticker: param,
        receiveAddress: receiveAddress
      });
      if (resData.data.length > 0 && resData.data[0].mode > 0) {
        amount = 0;
      }
    }  
    setReceiveTokenAmount(amount);
  }

  useEffect(() => {
    updateTokens(key, page);
  }, [param, page, ticker])

  const updateTokens = async (value, offset) => {
    setLoading(true);
    let data = await getAllBrc20ClaimData(
      {
        ticker: param,
        receiveAddress: value,
        offset: (offset - 1) * limit,
        limit: limit
      }
    );

    setTokens(data.data);
    setTotal(Math.ceil(data.total / limit))
    setClaimAmount(data.sum ?? 0);
    setLoading(false);
  }

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const debouncedSearch = useCallback(debounce((value) => {
    setPage(1);
    updateTokens(value, 1)
  }, 300), []); 

  const handleSearch = (value) => {
    setKey(value);
    debouncedSearch(value);
  };

  const handleMint = async () => {
    setLoading(true);
    setPayReceiveStatus(false);

    // if (mintStart == false) {
    //   toast.error(t('Please Wait Message'))
    //   setLoading(false);
    //   return;
    // }

    // if (mintHardEnd == true) {
    //   toast.error(t('Presale End Error Message'))
    //   setLoading(false);
    //   return;
    // }

    let resData = await getBrc20ClaimData({
      ticker: param,
      receiveAddress: receiveAddress
    });

    if (receiveAddress == "") {
      toast.error(t('Insert Valid Receiver Address Error Message'));
      setLoading(false);
      return;
    }

    // if (wallet.nostrOrdinalsAddress == "")
    // {
    //   toast.error(t('Connect Wallet Error Message'));
    //   setLoading(false);
    //   return;
    // }

    if (resData.data.length > 0 && resData.data[0].mode > 0) {
      toast.error(t('Already Claimed Error Message'));
      setLoading(false);
      return;
    }

    if (receiveTokenAmount == 0) {
      toast.error("This addres does not hold $TAP token.");
      setLoading(false);
      return;
    }
    
    if (!typeof window) {
      setLoading(false);
      return;
    }
    if (!window.tapscript) {
      setLoading(false);
      return;
    }

    let _privateKey = "";
    let _fundingAddress = "";
    let _inscriptionAddress = "";

    if (resData.data.length > 0) {
      setPrivateKey(resData.data[0].randomKey);
      _privateKey = resData.data[0].randomKey;
      _fundingAddress = resData.data[0].fundingAddress;
      _inscriptionAddress = resData.data[0].inscriptionAddress;
      setFundingAddress(_fundingAddress);
      setInscriptionAddress(_inscriptionAddress);
    }
    else {
      _privateKey = bytesToHex(cryptoUtils.Noble.utils.randomPrivateKey());
      setPrivateKey(_privateKey);
      let seckey = new KeyPair(_privateKey);
      let pubkey = seckey.pub.rawX;

      const ec = new TextEncoder();

      const init_script = [
        pubkey,
        'OP_CHECKSIG'
      ];
      
      const init_script_backup = [
          '0x' + buf2hex(pubkey.buffer),
          'OP_CHECKSIG'
      ];

      let init_leaf = await Tap.tree.getLeaf(Script.encode(init_script));
      let [init_tapkey, init_cblock] = await Tap.getPubKey(pubkey, {target: init_leaf});

      const test_redeemtx = Tx.create({
        vin  : [{
            txid: 'a99d1112bcb35845fd44e703ef2c611f0360dd2bb28927625dbc13eab58cd968',
            vout: 0,
            prevout: {
                value: 10000,
                scriptPubKey: [ 'OP_1', init_tapkey ]
            },
        }],
        vout : [{
            value: 8000,
            scriptPubKey: [ 'OP_1', init_tapkey ]
        }],
      });
      
      const test_sig = await Signer.taproot.sign(seckey.raw, test_redeemtx, 0, {extension: init_leaf});
      test_redeemtx.vin[0].witness = [ test_sig.hex, init_script, init_cblock ];
      const isValid = await Signer.taproot.verify(test_redeemtx, 0, { pubkey });

      if(!isValid)
      {
        alert('Generated keys could not be validated. Please reload the app.');
        setLoading(false);
        return;
      }

      _fundingAddress = Address.p2tr.encode(init_tapkey, encodedAddressPrefix);
      setFundingAddress(_fundingAddress);

      let files = [];

      let mimetype = "text/plain;charset=utf-8";

      for(let i = 0; i< 1; i++)
      {
        let text = `{"p":"brc-20","op":"transfer","tick":"TAP ","amt":"${receiveTokenAmount}"}`;
        console.log(text);
        files.push({
          text: JSON.stringify(text),
          name: textToHex(text),
          hex: textToHex(text),
          mimetype: mimetype,
          sha256: ''
        });
      }

      for (let i = 0; i < files.length; i++) {

        const hex = files[i].hex;
        const data = hexToBytes(hex);
        const mimetype = ec.encode(files[i].mimetype);

        const script = [
            pubkey,
            'OP_CHECKSIG',
            'OP_0',
            'OP_IF',
            ec.encode('ord'),
            '01',
            mimetype,
            'OP_0',
            data,
            'OP_ENDIF'
        ];

        const script_backup = [
            '0x' + buf2hex(pubkey.buffer),
            'OP_CHECKSIG',
            'OP_0',
            'OP_IF',
            '0x' + buf2hex(ec.encode('ord')),
            '01',
            '0x' + buf2hex(mimetype),
            'OP_0',
            '0x' + buf2hex(data),
            'OP_ENDIF'
        ];

        const leaf = await Tap.tree.getLeaf(Script.encode(script));
        const [tapkey, cblock] = await Tap.getPubKey(pubkey, { target: leaf });

        _inscriptionAddress = Address.p2tr.encode(tapkey, encodedAddressPrefix);
        setInscriptionAddress(_inscriptionAddress);
      }
    }

    if (resData.data.length == 0) {
      await saveBrc20ClaimData({
        ticker: "TAP ",
        receiveAddress: receiveAddress,
        randomKey: _privateKey,
        mode: 0, // create
        fundingAddress: _fundingAddress,
        inscribeAmount: receiveTokenAmount,
        inscriptionAddress: _inscriptionAddress,
        feerate: feerate,
        fundingAmount: fees.totalFee
      });
    }
    else {
      await updateBrc20ClaimData({
        mode: 0,
        feerate: feerate,
        fundingAmount: fees.totalFee
      })
    }

    setLoading(false);
    setShow(true);
  }

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  const handleAddress = (value) => {
    setReceiveAddress(value)
  }

  const handleCopy = (value, mode = 0) => {
    navigator.clipboard.writeText(value).then(
      () => {
        // Successfully copied to clipboard
        if (mode == 1)
          toast.success(t('Name Copied!'));
        else
          toast.success(t('Copied!'));
      },
      (err) => {
        // Failed to copy to clipboard
        console.error('Could not copy address: ', err);
      }
    );
  }

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const handleOpen = (value) => setOpen(open === value ? 0 : value);

  const handlePay = async () => {
    setPayStatus(true);
    let res = await getPaymentUtxos(wallet.nostrPaymentAddress, [fundingAddress], fees.totalFee, "", 0, wallet.paymentPublicKey, feerate, 1, wallet.domain);

    let isSuccess = true;
    if (res.status != "success") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      setPayStatus(false);
      isSuccess = false;
      return;
    }
    try{
        if (wallet.domain == "tapwallet") {
          const signedPsbt = await window.tapwallet.signPsbt(res.psbt);
          const txid = await window.tapwallet.pushPsbt(signedPsbt);
        }
        else if (wallet.domain == "unisat") {
          const signedPsbt = await window.unisat.signPsbt(res.psbt);
          const txid = await window.unisat.pushPsbt(signedPsbt);
        }
        else if (wallet.domain == "okxwallet") {
          const signedPsbt = await window.okxwallet.bitcoin.signPsbt(res.psbt);
          const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
        }
        else if (wallet.domain == "xverseWallet") {
          if (res.status == "success") {
            let signIndexes = [];
            for(let i=0;i<res.count; i++){
              signIndexes.push(i);
            }
   
            await signTransaction({
              payload: {
                  network: {
                      type: BitcoinNetworkType.Mainnet,
                  },
                  psbtBase64: res.psbt,
                  broadcast: true,
                  message: "tip the author! Don't worry this will not be broadcasted.",
                  inputsToSign: [
                      {
                          address: wallet.nostrPaymentAddress,
                          signingIndexes: signIndexes,
                      },
                  ],
              },
              onFinish: async (response) => {
  
              },
              onCancel: () => {
                  alert(t('Request canceled'));
                  setShow(false);
                  setLoading(false);
                  isSuccess = false;
                  setPayStatus(false);
              },
            });
    
          }
          else {
            alert(t('Insufficient Balance Error Message'));
            setLoading(false);
            setShow(false);
            setPayStatus(false);
            isSuccess = false;
            return;
          }
        }
        else if (wallet.domain == "magiceden") {
          if (res.status == "success") {
            let signIndexes = [];
            for(let i=0;i<res.count; i++){
              signIndexes.push(i);
            }
  
            let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);
  
            await signTransaction({
              getProvider: async () =>
                magicedenWallets[0].features['sats-connect:'].provider,
              payload: {
                  network: {
                      type: BitcoinNetworkType.Mainnet,
                  },
                  psbtBase64: res.psbt,
                  broadcast: true,
                  message: "tip the author! Don't worry this will not be broadcasted.",
                  inputsToSign: [
                      {
                          address: wallet.nostrPaymentAddress,
                          signingIndexes: signIndexes,
                      },
                  ],
              },
              onFinish: async (response) => {
              },
              onCancel: () => {
                  alert(t('Request canceled'));
                  setShow(false);
                  setLoading(false);
                  setPayStatus(false);
                  isSuccess = false;
              },
            });
    
          }
        }
        else {
          toast.error("This wallet does not support yet. Please wait!");
          setLoading(false);
          setShow(false);
          setPayStatus(false);
          isSuccess = false;
          return;
        }
      }
      catch(e)
      {
        console.log(e);
        alert("Payment rejected by user. Try again.");
        setLoading(false);
        setShow(false);
        setPayStatus(false);
        isSuccess = false;
        return;
      }
  
      if (isSuccess) {
        return;
      }
  
      setLoading(false);
      setShow(false);
      setPayStatus(false);
  }

  const handlePaySuccess = async (transactionData) => {
    // step 1: transfer fund
    // save fund received
    await updateBrc20ClaimData({
      randomKey: privateKey,
      mode: 1
    });

    let seckey = new KeyPair(privateKey);
    let pubkey = seckey.pub.rawX;

    const ec = new TextEncoder();

    const init_script = [
      pubkey,
      'OP_CHECKSIG'
    ];
    
    const init_script_backup = [
        '0x' + buf2hex(pubkey.buffer),
        'OP_CHECKSIG'
    ];

    let init_leaf = await Tap.tree.getLeaf(Script.encode(init_script));
    let [init_tapkey, init_cblock] = await Tap.getPubKey(pubkey, {target: init_leaf});

    const test_redeemtx = Tx.create({
      vin  : [{
          txid: 'a99d1112bcb35845fd44e703ef2c611f0360dd2bb28927625dbc13eab58cd968',
          vout: 0,
          prevout: {
              value: 10000,
              scriptPubKey: [ 'OP_1', init_tapkey ]
          },
      }],
      vout : [{
          value: 8000,
          scriptPubKey: [ 'OP_1', init_tapkey ]
      }],
    });
    
    const test_sig = await Signer.taproot.sign(seckey.raw, test_redeemtx, 0, {extension: init_leaf});
    test_redeemtx.vin[0].witness = [ test_sig.hex, init_script, init_cblock ];
    const isValid = await Signer.taproot.verify(test_redeemtx, 0, { pubkey });

    if(!isValid)
    {
      alert('Generated keys could not be validated. Please reload the app.');
      return;
    }

    let files = [];

    let mimetype = "text/plain;charset=utf-8";

    for(let i = 0; i< 1; i++)
    {
      let text = `{"p":"brc-20","op":"transfer","tick":"TAP ","amt":"${receiveTokenAmount}"}`;
      
      // let text = `{"p":"brc-20","op":"transfer","tick":"𒄆","amt":"${receiveTokenAmount}"}`;

      files.push({
        text: JSON.stringify(text),
        name: textToHex(text),
        hex: textToHex(text),
        mimetype: mimetype,
        sha256: ''
      });
    }

    let inscriptions = [];
    let inscriptionAddressList = [];

    for (let i = 0; i < files.length; i++) {

      const hex = files[i].hex;
      const data = hexToBytes(hex);
      const mimetype = ec.encode(files[i].mimetype);

      const script = [
          pubkey,
          'OP_CHECKSIG',
          'OP_0',
          'OP_IF',
          ec.encode('ord'),
          '01',
          mimetype,
          'OP_0',
          data,
          'OP_ENDIF'
      ];

      const script_backup = [
          '0x' + buf2hex(pubkey.buffer),
          'OP_CHECKSIG',
          'OP_0',
          'OP_IF',
          '0x' + buf2hex(ec.encode('ord')),
          '01',
          '0x' + buf2hex(mimetype),
          'OP_0',
          '0x' + buf2hex(data),
          'OP_ENDIF'
      ];

      const leaf = await Tap.tree.getLeaf(Script.encode(script));
      const [tapkey, cblock] = await Tap.getPubKey(pubkey, { target: leaf });

      let inscriptionAddress = Address.p2tr.encode(tapkey, encodedAddressPrefix);

      let prefix = 160;

      let txsize = prefix + Math.floor(data.length / 4);

      inscriptionAddressList.push(inscriptionAddress);

      inscriptions.push(
        {
          leaf: leaf,
          tapkey: tapkey,
          cblock: cblock,
          inscriptionAddress: inscriptionAddress,
          txsize: txsize,
          fee: fees.inscribeFee - padding,
          script: script_backup,
          script_orig: script
        }
      );
    }

    let outputs = [];

    let transaction = [];
    
    // create fund transfer outputs
    outputs.push(
      {
        value: fees.inscribeFee,
        scriptPubKey: [ 'OP_1', inscriptions[0].tapkey ]
      }
    )

    outputs.push(
      {
        value: fees.transferFee,
        scriptPubKey: [ 'OP_1', Address.p2tr.decode(brc20ClaimOwnerAddress, encodedAddressPrefix).hex ]
      }
    );

    outputs.push(
      {
        value: fees.serviceFee,
        scriptPubKey: [ 'OP_1', Address.p2tr.decode(brc20ClaimFeeAddress, encodedAddressPrefix).hex ]
      }
    )

    const init_redeemtx = Tx.create({
      vin  : [{
          txid: transactionData.txid,
          vout: transactionData.vout,
          prevout: {
              value: transactionData.value,
              scriptPubKey: [ 'OP_1', init_tapkey ]
          },
      }],
      vout : outputs
    })

    const init_sig = await Signer.taproot.sign(seckey.raw, init_redeemtx, 0, {extension: init_leaf});
    init_redeemtx.vin[0].witness = [ init_sig.hex, init_script, init_cblock ];

    let rawtx = Tx.encode(init_redeemtx).hex;

    let fundTransactionId = "";

    while(true) {
      let _txid = await broadcastBitcoinTransaction(rawtx);
      if (_txid.length == 64) {  // register
        await updateBrc20ClaimData({
          randomKey: privateKey,
          mode: 2, // transfer
          transactionId: _txid
        });
        fundTransactionId = _txid;
        break;
      }
      await sleep(5000);
    }

    if (fundTransactionId != "") {
      // inscribe ordinal
      let _toAddress = Address.p2tr.decode(brc20ClaimOwnerAddress, encodedAddressPrefix).hex;
      let _script = [ 'OP_1', _toAddress ];

      const redeemtx = Tx.create({
        vin  : [{
            txid: fundTransactionId,
            vout: 0,
            prevout: {
                value: fees.inscribeFee,
                scriptPubKey: [ 'OP_1', inscriptions[0].tapkey ]
            },
        }],
        vout : [{
            value: padding,
            scriptPubKey: _script
        }],
      });

      const sig = await Signer.taproot.sign(seckey.raw, redeemtx, 0, {extension: inscriptions[0].leaf});
      redeemtx.vin[0].witness = [ sig.hex, inscriptions[0].script_orig, inscriptions[0].cblock ];
  
      let rawtx2 = Tx.encode(redeemtx).hex;
      let _txid2;
  
      while(true) {
        _txid2 = await broadcastBitcoinTransaction(rawtx2);
        if (_txid2.length == 64) {
          // save inscriptionId
          await updateBrc20ClaimData({
            randomKey: privateKey,
            mode: 3, // inscribe
            inscriptionId: _txid2
          });
          break;
        }
        await sleep(5000);
      }

      // send inscription transfer

      let transactionParam = {
        utxos : [
          {
            txid : _txid2,
            vout : 0,
            value : padding,
          },
          {
            txid : fundTransactionId,
            vout : 1,
            value : fees.transferFee,
          }
        ],
        outputAddress : receiveAddress,
        outputAmount : padding,
      }

      let transactionData = await getBrc20ClaimTransactionData(transactionParam);

      while(true) {
        let txid = await broadcastBitcoinTransaction(transactionData.hex);
        if (txid.length == 64) {
          await updateBrc20ClaimData({
            randomKey: privateKey,
            mode: 4, // send
          });
          break;
        }
        await sleep(5000);
      }
      setTransactionStatus(true);

      await updateTokens("", 1);
    }
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col justify-center items-center mb-10 min-h-[600px]">
      {

        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed bg" color="pink"/> : <></>
      }
      <div className="flex flex-row gap-5 mt-10 items-center">
        <div className="md:flex hidden text-white font-bold text-[44px]">{t('BRC-20')}</div>
        <div className="text-white font-bold text-[44px] bg-primary rounded-md px-4 py-2">TAP</div>
        <div className="md:flex hidden text-white font-bold text-[44px]">{t('CLAIM')}</div>
      </div>
      <div className="flex flex-row text-white max-w-[600px] mt-3 font-bold text-[18px] text-center">
        {description}
      </div>
      {/* <div className="sm:w-[600px] w-full flex flex-col gap-1 text-white font-semibold sm:text-[20px] text-[18px] mt-5 pt-2 sm:pb-4 pb-2 px-4 border-[1px] border-dashed border-gray-800 rounded-lg">
        <div className="flex flex-row justify-between">
          <span className="ml-3">{t('TIME REMAINING')}</span>
          {
            percent > 0 ?
            <span className="mr-3 sm:flex hidden">({timeLeft.days}D {timeLeft.hours}H {timeLeft.minutes}M {timeLeft.seconds}S)</span>
            :
            <></>          
          }
        </div>
        
        <Progress  value={percent} color="blue" size="md" />
        {
          percent > 0 ?
          <span className="ml-3 sm:hidden flex">({timeLeft.days}D {timeLeft.hours}H {timeLeft.minutes}M {timeLeft.seconds}S)</span>
          :
          <></>          
        }
      </div> */}
      <div className="sm:w-[600px] w-full flex flex-col gap-1 text-white font-semibold sm:text-[20px] text-[18px] mt-5 py-2 px-4 border-[1px] border-dashed border-gray-800 rounded-lg">
        <div className="flex flex-row justify-between">
          <div className="ml-3">
            <span>{t('Progress')}</span>
            <span className="ml-1">({formatFloat(claimAmount * 100 / deployLimit, 2)}%)</span>
          </div>
        </div>
        
        <Progress value={formatFloat(claimAmount * 100 / deployLimit, 2)} color="blue" size="md" />
        <div className="flex flex-row">
          <span className="ml-3"> {parseFloat(claimAmount)} {t('CLAIMED')}</span>
        </div>
      </div>
      {
        mintEnd ? 
        <></>
        :
        <div className="flex flex-row gap-3 mt-5">
          <CountdownCard placeholder = {"DAYS"} number = {timeLeft.days}/>
          <CountdownCard placeholder = {"HOURS"} number = {timeLeft.hours}/>
          <CountdownCard placeholder = {"MINUTES"} number = {timeLeft.minutes}/>
          <CountdownCard placeholder = {"SECONDS"} number = {timeLeft.seconds}/>
        </div>
      }
      <div className="md:min-w-[600px] min-w-[300px] border-gray-800 border-[1px] border-solid md:p-8 p-4 rounded-lg mt-5 flex flex-col gap-8 bg-[#081817] md:w-[600px] w-full">
        <div>
          <Input type="text" color="white" label = {t('Receive Address')} className="w-full md:min-w-[500px] min-w-[250px]" value={receiveAddress} onChange = {(e) => {handleAddress(e.target.value)}}/>
        </div>
        <div className="sm:text-[18px] text-[14px]">
          {t('Select Network Fee You Want')}:
        </div>
        <div className="grid grid-cols-3 gap-3">
          <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
          <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
          <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
        </div>
        {
          feeRateMode == "Custom" ? 
          <div className="flex flex-row gap-3 items-center">
            <Slider className="sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
            <div className="sm:max-w-[200px] w-full">
              <Input type="text" color="white" label = {t('Custom Fee')} className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
            </div>
          </div>
          : 
          <></>
        }
        <div className="flex flex-col gap-2 text-[18px] justify-center items-center">
          {/* <div className="text-[18px]">Total Fee: <span className="font-bold text-primary">{fees.totalFee / Math.pow(10, 8)} BTC (${formatFloat(fees.totalFee / Math.pow(10, 8) * prices.bitcoin, 2)})</span></div> */}
          <div className="text-[18px]">Claim Amount: <span className="font-bold text-primary">{receiveTokenAmount} {param.toLocaleUpperCase()}</span></div>
        </div>
        <div className="flex flex-row w-full justify-center gap-3">
          <button className="bg-primary hover:bg-primary-hover rounded-md py-2 md:px-6 px-3 cursor-pointer" onClick={handleMint}>{t('CLAIM')}</button>
        </div>
      </div>
      <Dialog
        open={show}
        size={isMobile ? 'xl' : 'sm'}
        className="bg-black border-gray-800 border-[1px] border-solid"
      >
        <DialogBody>
          <div className="flex flex-col gap-3 w-full min-h-[200px] items-center justify-center md:px-4 md:py-4 px-0 py-3 relative">
            <XMarkIcon className="h-7 w-7 cursor-pointer text-gray-400 font-bold absolute top-0 right-0" onClick={() => {setShow(false)}} />
            {
              transactionStatus == false ?
              <>
                <Accordion open={open === 0} className="mt-5 mb-2 rounded-lg border-solid border-[2px] border-gray-500 md:px-4 px-2">
                  <AccordionHeader onClick={() => handleOpen(0)} className={` hover:text-primary border-b-0 mb-0 sm:text-[20px] text-[16px] font-bold ${open === 0 ? 'text-primary pb-0' : 'text-white'}`}>
                    {t('Continue With Connected Wallet')}
                  </AccordionHeader>
                  <AccordionBody>
                    {
                      payStatus == false ?
                      <div className="flex flex-row md:gap-4 gap-2 justify-center items-center py-3 text-white">
                        <Connect />
                        {
                          wallet.nostrPaymentAddress != "" ?
                          <div className="bg-primary hover:bg-primary-hover rounded-md text-[16px] cursor-pointer font-bold py-3 px-10 text-white" onClick={() => {handlePay()}}>
                            {t('Claim')}
                          </div>
                          :
                          <></>
                        }
                      </div>
                      :
                      <div className="flex flex-row gap-2 justify-center items-center py-3">
                        <Spinner className="h-16 w-16 text-gray-900/50" color="pink"/>
                      </div>
                    }
                  </AccordionBody>
                </Accordion>

                <Accordion open={open === 1}  className="mt-5 mb-2 rounded-lg border-solid border-[2px] border-gray-500 md:px-4 px-2">
                  <AccordionHeader onClick={() => handleOpen(1)} className={` hover:text-primary border-b-0 mb-0 sm:text-[20px] text-[16px] font-bold ${open === 1 ? 'text-primary pb-0' : 'text-white'}`}>
                    {t('Continue Manually With BTC')}
                  </AccordionHeader>
                  <AccordionBody>
                    <div className="flex flex-col gap-3 justify-center items-center">
                      <div className="text-white text-[18px] mt-3">{t('Scan QR Code:')}</div>
                      <div className="p-2 border-gray-800 border-[1px] border-solid rounded-lg">
                        <BitcoinQRCode address={fundingAddress} amount={fees.totalFee / Math.pow(10, 8)} />
                      </div>
                      <div className="text-white text-[18px]">{t('Or pay to the address below:')}</div>
                      <div className="flex flex-row gap-2 items-center">
                        <div className="text-white font-semibold md:flex hidden text-[20px]">{formatInscriptionId(fundingAddress)}</div>
                        <div className="text-white font-semibold md:hidden flex text-[20px]">{formatAddress(fundingAddress)}</div>
                        <DocumentDuplicateIcon className="h-5 w-5 cursor-pointer text-primary" onClick={() => {handleCopy(fundingAddress)}} />
                      </div>
                      <div className="flex flex-row gap-2 items-center">
                        <div className="text-white font-semibold text-[20px]">{formatFloat(fees.totalFee / Math.pow(10, 8), 8)} BTC</div>
                        <DocumentDuplicateIcon className="h-5 w-5 cursor-pointer text-primary" />
                      </div>
                      <div className="text-red-800 text-[16px] font-bold">{t('Do Not Close Window Info Message')}</div>
                      <Spinner className="h-16 w-16 text-gray-900/50" color="pink"/>
                    </div>
                  </AccordionBody>
                </Accordion>
              </>
              :
              <>
                <CheckCircleIcon strokeWidth={2} className="h-24 w-24 text-primary" /> 
                <div className="flex flex-row text-primary font-bold sm:text-[24px] text-[20px] text-center">{t('Claim Complete.')}</div>
              </> 
            }
          </div>
        </DialogBody>
      </Dialog>
      {
        flag == 1 ?
        <div className="md:min-w-[600px] min-w-[300px] flex flex-col mt-10 mb-10 md:w-[600px] w-full">
          <Input type="text" color="white" label = {t('Search by address')} className="w-full md:min-w-[500px] min-w-[250px]" value = {key}
                      onChange = {(e) => {handleSearch(e.target.value)}}/>
          <div className="w-full border-gray-800 border-[1px] border-solid rounded-lg mt-4 bg-[#081817]">
            <div className="w-full grid grid-cols-2 py-4 px-6 bg-[#1e1f1f]">
              <div>{t('Address')}</div>
              <div>{t('Amount')}</div>
            </div>
            {
              tokens.length == 0 ? <div className="w-full flex flex-row py-4 px-6 text-gray-500 hover:bg-[#121313] justify-center">{t('Loading...')}</div> : 
              <>
                {
                  tokens.map((data) => {
                    return (
                      <div className="w-full grid grid-cols-2 py-4 px-6 text-gray-500 hover:bg-[#121313] cursor-pointer" key={uuidv4()}>
                        <div onClick={() => handleCopy(data.receiveAddress, 2)}>{formatAddress(data.receiveAddress)}</div>
                        <div>{parseFloat(data.inscribeAmount)}</div>
                      </div>
                    )
                  })
                }
              </>
            }
          </div>
          {
            total > 1 ? 
            <div className="flex flex-row items-center gap-8 justify-end mt-5">
              <IconButton
                size="sm"
                variant="outlined"
                onClick={prev}
                disabled={page === 1}
                className="bg-primary hover:bg-primary-hover"
              >
                <ArrowLeftIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <Typography color="white" className="font-normal">
                {t('Page')} <strong className="text-primary">{page}</strong> of{" "}
                <strong className="text-primary">{total}</strong>
              </Typography>
              <IconButton
                size="sm"
                variant="outlined"
                onClick={next}
                disabled={page === total}
                className="bg-primary hover:bg-primary-hover"
              >
                <ArrowRightIcon strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
            :
            <></>
          }
        </div>
        :
        <></>
      }
    </div>
  )
}
